/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const ComboCreatePage = lazyLoad(
  () => import('./index'),
  module => module.ComboCreatePage
);
